import {
  createSlice,
} from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { IInitialState } from "./Types";

const initialState: IInitialState = {
  text: "",
  show: false
};

export const Slice = createSlice({
  initialState,
  name: "progress-spinner",
  reducers: Reducer,
});
